export default "__VITE_PUBLIC_ASSET__de9aa301__"